import { toast } from 'react-toastify';
 
const API_BASE = process.env.REACT_APP_BACKEND_URL;
 
export const getSharePointCredentialsAndCreateToken = async (connectorId, mcId, masterConnectors = []) => {
  if (!API_BASE) throw new Error('REACT_APP_BACKEND_URL is not set');
  if (!mcId) throw new Error('Missing Master Connector ID (mcId)');
  if (!connectorId) throw new Error('Missing Sync Connector ID (connectorId)');
 
  console.log('🔵 getSharePointCredentialsAndCreateToken called');
  console.log('   connectorId:', connectorId);
  console.log('   mcId:', mcId);
 
  // Validate master connector exists
  if (Array.isArray(masterConnectors) && masterConnectors.length > 0) {
    const spMc = masterConnectors.find(
      (mc) =>
        (mc.mcRecId?.toString() === mcId?.toString() || mc.mcId?.toString() === mcId?.toString()) &&
        (mc.mcName === 'SharePoint' || mc.provider === 'SharePoint' || mc.type === 'SharePoint')
    );
    if (!spMc) {
      throw new Error('SharePoint master connector not found');
    }
    console.log('✅ SharePoint master connector validated:', spMc.mcName);
  }
 
  // Get app-only access token from backend
  console.log('📡 Requesting app token from backend...');
  const tokenData = await requestSharePointAppToken(mcId);
  console.log('✅ Token received from backend');
 
  // Update SyncConnector row
  console.log('📝 Updating connector with token...');
  await updateConnectorWithSharePointToken(connectorId, tokenData);
  console.log('✅ Connector updated successfully');
 
  return tokenData;
};
 
const requestSharePointAppToken = async (mcId) => {
  console.log('🔑 Requesting new SharePoint token...');
  const response = await fetch(`${API_BASE}synctrack/sharepoint/validToken`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify({ 
      mcId: mcId.toString(),
      forceNew: true // Always force a new token
    })
  });
 
  if (!response.ok) {
    const errorText = await response.text();
    console.error('❌ SharePoint token request failed:', errorText);
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const tokenData = await response.json();
  console.log(' Received new SharePoint token');
  console.log('   Token:', tokenData.access_token ? `${tokenData.access_token.substring(0, 20)}...` : 'No token');
  console.log('   Type:', tokenData.token_type || 'Bearer');
  console.log('   Expires in:', tokenData.expires_in || 'N/A', 'seconds');
  
  return tokenData;
};
 
const updateConnectorWithSharePointToken = async (connectorId, tokenData) => {
  const expiresInMs = (tokenData.expires_in || 3600) * 1000;
  
  // Format the data to match the SyncConnector entity
  const updatedData = {
    token: tokenData.access_token, // Just the token string, not the whole object
    tokenExpiry: new Date(Date.now() + expiresInMs).toISOString(),
    status: 'Connected',
    connectedTime: new Date().toISOString(),
    // Explicitly set other required fields to null if they're not needed
    refreshToken: null,
    refreshTokenExpiry: null,
    refreshUrl: null
  };

  console.log('Sending update to sync-connectors:', {
    connectorId,
    data: updatedData
  });

  const response = await fetch(`${API_BASE}synctrack/sync-connectors/${connectorId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(updatedData)
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('SharePoint connector update failed:', {
      status: response.status,
      statusText: response.statusText,
      errorText
    });
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const responseData = await response.json();
  console.log('Update successful:', responseData);
  return responseData;
};